import { MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useMemo, useState } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import PopupLoader from "../../../views/popups/PopupLoader";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaLocation({ locations, setValue, control, reset, clearErrors, errors }) {
  const [selectAllRadio, setselectAllRadio] = useState("-1");
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [columnName, setcolumnName] = useState("");
  const [editWarning, seteditWarning] = useState(false);

  // const { setValue, control, reset, clearErrors, formState : {errors} } = useFormContext();

  const { fields } = useFieldArray({
    name: "loc.edit_perm",
    control,
  });

  // Replacing watch with useWatch
  const isPermEnabled = useWatch({ control, name: "loc.is_perm_enabled" });
  const locEditPerm = useWatch({ control, name: "loc.edit_perm" });

  useEffect(() => {
    if (locations && locations.length > 0) {
      reset((prev) => ({
        ...prev,
        loc: { ...prev.loc, edit_perm: locations },
      }));
    }
  }, [locations, reset]);

  function handleAllChange(fieldName, columnName, value) {
    clearErrors(`loc.is_perm_enabled`);
    if (value !== "-1") {
      setupdateFieldName(fieldName);
      setupdateFieldValue(value);
      seteditWarning(true);
      setcolumnName(columnName);
    }
  }
  const handleSearch = (value) => {
    // setSearchValue(value);
    if (!value) {
      reset((prev) => ({
        ...prev,
        loc: { ...prev.loc, edit_perm: locations },
      }));
      return;
    }
    const filterResult = customSearch(locations, value, ["name", "address"]);
    reset((prev) => ({
      ...prev,
      loc: { ...prev.loc, edit_perm: filterResult },
    }));
  };

  function handleCloseWarning() {
    setselectAllRadio("-1");
    seteditWarning(false);
  }

  function handleUpdateToggle() {
    fields.forEach((field, index) => {
      setValue(`loc.edit_perm.${index}.${updateFieldName}`, updateFieldValue ? 1 : 0, {
        shouldDirty: true,
      });
    });

    setselectAllRadio("-1");
    seteditWarning(false);
  }

  const processedRows = useMemo(() => {
    return fields.map((loc, index) => ({
      locInfo: loc,
      name: loc.name,
      locTypes: loc.location === 1 ? (
        <div className="py-1 px-3 m-0 primary-location rounded-pill d-inline custom-make-primary">
          Primary
        </div>
      ) : (
        ""
      ),
      address: loc.address,
      active: (
        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              name="DefualtLocation"
              checked={locEditPerm?.[index]?.flag === 1}
              onChange={(e) => {
                clearErrors(`loc.is_perm_enabled`);
                setValue(`loc.edit_perm.${index}.flag`, e.target.checked ? 1 : 0, {
                  shouldDirty: true,
                })
              }
              }
            />
            <span className="slider round"></span>
          </label>
        </div>
      ),
    }));
  }, [fields, locEditPerm]);

  const actionData = {
    columns: [
      { label: "Name", field: "name" },
      { label: "", field: "locTypes", sort: false, colSpan: 1 },
      { label: "Address", field: "address" },
      {
        label: (
          <div className="d-flex align-items-center flex-column justify-content-center">
            <p className="fw-bold">Active</p>
            <div className="three-checkbox round2 mx-0">
              <input
                type="radio"
                name="ActiveValue01"
                checked={selectAllRadio === false}
                onChange={() => {
                  setselectAllRadio(false);
                  handleAllChange("flag", "Active", false);
                }}
              />
              <input
                type="radio"
                name="ActiveValue01"
                checked={selectAllRadio === "-1"}
                onChange={() => {
                  setselectAllRadio("-1");
                  handleAllChange("flag", "Active", "-1");
                }}
              />
              <input
                type="radio"
                name="ActiveValue01"
                checked={selectAllRadio === true}
                onChange={() => {
                  setselectAllRadio(true);
                  handleAllChange("flag", "Active", true);
                }}
              />
              <span className="slider"></span>
            </div>
          </div>
        ),
        field: "active",
        sort: false,
      },
    ],
    rows: processedRows,
  };




  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('.luna-location-table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (trimmed && td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles(); // Initial patch

    const table = document.querySelector('.luna-location-table');
    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [isPermEnabled, processedRows]);


  return (
    <>
      <div className="section-content">
        <div className="general-settings">Locations</div>

        <div className="add-numbermain pe-4">
          <div>
            <div className="tel-numbers">
              Use a specific location or set of locations
            </div>
            <span className="phrecording">
              By default Luna will know users and system extensions from all locations
            </span>
          </div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                value={isPermEnabled}
                checked={isPermEnabled}
                onChange={(e) => {
                  clearErrors(`loc.is_perm_enabled`);
                  setValue("loc.is_perm_enabled", e.target.checked, {
                    shouldDirty: true,
                  })
                }
                }
              />
              <span className="slider round"></span>
            </label>
            {errors?.loc?.is_perm_enabled && (
              <p className="text-danger">{errors.loc.is_perm_enabled.message}</p>
            )}
          </div>
        </div>
        {isPermEnabled && (
          <>
            <div className="actionbar"></div>
            <div className='mb-2 mt-0 position-relative w-auto'>
              <MDBInput
                label="Search"
                // value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <MDBDatatable
              className="actioncolumn luna-location-table top-15Icon"
              hover
              // search
              maxHeight="40vh"
              fixedHeader
              data={actionData}
            />
          </>
        )}
      </div>
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={null}
              columnName={columnName}
              isLuna={true}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}
    </>
  );
}

export default LunaLocation;

